var levelMeta = [
	{
		category: 1,
		title: 'Du er en ekte ingenørd!',
		blocks: [
			`Du er en <strong>ekte</strong>`,
			`ingenørd!`
		],
		facebook: 'Gratulerer, du er blant de få som kan benytte hedersbetegnelsen ingenørd. De kaller deg ingeniørenes ingeniør bak ryggen din, og du bryr deg ikke om hvorvidt det er et kompliment eller ikke. Så lenge du får fortsette å dyrke faget ditt og interessene dine er du i ditt ess. Du er en ressursperson for teamet ditt – bare husk å snakk et språk de rundt deg forstår. ',
		intro: `<p>Gratulerer, du er blant de få som kan benytte hedersbetegnelsen ingenørd. </p>

		<p>De kaller deg ingeniørenes ingeniør bak ryggen din, og du bryr deg ikke om hvorvidt det er et kompliment eller ikke. Så lenge du får fortsette å dyrke faget ditt og interessene dine er du i ditt ess. Du er en ressursperson for teamet ditt – bare husk å snakk et språk de rundt deg forstår.</p>
		`,
		
	},
	{
		category: 2,
		title: 'Du har sterke ingenørd-tendenser',
		blocks: [
			`Du har sterke`,
			`ingenørd tendenser.`,
		],
		facebook: 'Du har en unik evne til å fordype deg i faget eller hobbyen din, og har mer spisskompetanse enn de fleste. Du har tydelige ingenørd-tendenser. ',
		intro: `<p>Du har en unik evne til å fordype deg i faget eller hobbyen din, og har mer spisskompetanse enn de fleste. </p>

		<p>Du har likefremt noe mer allsidig kompetanse og interesser enn en fullstøp ingenørd. Disse egenskapene gjør at du ofte opptrer som en oversetter eller lynavleder mellom ingenørden og en motpart.</p>
		`,

	},
	{
		category: 3,
		title: 'Du har ingenørd-potensiale',
		blocks: [
			`Du har`,
			`ingenørd-potensial.`,
		],
		facebook: 'Du har ingenørd-potensiale, men er nok best som allrounder. ',
		intro: `<p>Din indre ingeniør kan fortsatt utvikles. Kanskje trives du også best som en allrounder?

		Du har trolig en ingenørd i teamet ditt, som spør deg om råd når du står fast.</p>
`,
		
	},
	{
		category: 4,
		title: 'Du er kanskje hverken ingeniør eller nerd?',
		blocks: [
			`Du er kanskje`,
			`hverken ingeniør`,
			`eller nerd?`
		],
		facebook: 'Jeg er åpenbart ingen ingenørd. ',
		intro: `<p>Men slapp av, det er ingen skam å ikke være ingenørd. En arbeidsplass trenger balanse i de ansatte –både spesialister
		og allroundere.</p>
`,
		
	}
];

export default levelMeta;


// WEBPACK FOOTER //
// ./src/appdata/results.js